import CryptoJS from "crypto-js";

class TextHelper {
  CreateToken(message: string): string {
    const secret = "puuntrueincube210414";
    const hash = CryptoJS.HmacSHA256(message, secret);
    const hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    return hashInBase64;
  }
}

export default new TextHelper();
